// extracted by mini-css-extract-plugin
export var explainable = "_jg-a";
export var printerCard = "_jg-1";
export var printerCardConfigured = "_jg-2";
export var printerCardError = "_jg-3";
export var printerCardsContainer = "_jg-0";
export var printerIcon = "_jg-8";
export var printerIconConfigured = "_jg-5";
export var printerIconContainer = "_jg-4";
export var printerIconError = "_jg-6";
export var printerIconUnconfigured = "_jg-7";
export var workstationsTableCard = "_jg-9";